export default "__VITE_ASSET__bbc31b34__"